const styles = {
  container: '',

  list: 'flex flex-row h-[14rem] sm:h-[25rem] gap-1',

  viewer: {
    container: 'fixed left-0 top-0 right-0 bottom-0 z-50 bg-teal-rgba',
    content: '',
    navigation: {
      container: 'w-full h-screen p-4 sm:p-8 h-screen fixed',

      head: 'w-full flex flex-row items-center justify-between',
      body: 'w-full h-full flex flex-row items-center justify-between',

      content: '  text-white text-sm',
      alt: 'font-semibold',
      date: 'font-light',
    },

    button:
      'aspect-square w-12 bg-gray-200 text-gray-800 rounded-full flex items-center justify-center',
  },

  tiles: {
    primary: 'w-full',
    secondary: 'w-[36rem] flex flex-col gap-1',
    tertiary: 'h-full flex flex-row gap-1',
    button:
      'w-full h-full bg-[#0F3E48] rounded-sm flex items-center justify-center text-white   font-semibold text-5xl hover:bg-secondary-800/90 cursor-pointer',
  },
};

export default styles;
